module.exports = __webpack_public_path__ + "static/media/Hyppig.2dc37cfe.m4a";